import React from 'react';
import { EyeIcon, ClockIcon, BadgeCheck } from 'lucide-react';
const HeaderGlpPlateau3 = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-18009" data-mp="105uv9bijgvl1">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-18010" data-mp="14y65b76ztxrb"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-18011" data-mp="18xofp916uqfw">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-18012" data-mp="c9h12zan5cbc">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-18013" data-mp="cb1wss8oz1as">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-18014" data-mp="l8c6wa9rwke4">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-18015" data-mp="1wp26hajoydyr">
          <div className="text-left" data-id="element-18016" data-mp="21mc3pcdbntx5">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-18017" data-mp="2bmq6czpfxtmb">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-18018" data-mp="1sodx7dyj4jqq">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-18019" data-mp="1nvks2oz5f9e4">
        <div className="max-w-4xl mx-auto" data-id="element-18020" data-mp="1iyudk62zslut">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-18021" data-mp="1dz9gk17dunkq">
            GLP-1 NEWS
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-18022" data-mp="18zmxhb4vid40">
            Dr. Reed: Why Your Body Is Fighting Your GLP-1 — And How To Stop It
          </h1>
          <p className="text-sm sm:text-base text-gray-500 italic mb-6" data-id="element-18023" data-mp="ubwhuqer0n91">
            (From a Metabolic Specialist Who Spent 18 Months Trying To Solve Her
            Own Plateau)
          </p>

          {/* Author Byline */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-gray-200" data-id="element-18024" data-mp="lf4amnuu4gml">
            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0 bg-gray-200" data-id="element-18025" data-mp="qdypxftlfn1y">
              <img src="https://cdn.magicpatterns.com/uploads/njKHWtEUNXzL7WtDqVKiu5/pasted-image.jpg" alt="Dr. Patricia Reed" className="w-full h-full object-cover" data-id="element-18026" data-mp="1e3jm50ercgt6" />
            </div>
            <div className="flex-1" data-id="element-18027" data-mp="14b41twfzng54">
              <div className="flex items-center gap-2 mb-2" data-id="element-18028" data-mp="19aqfg6zqayeg">
                <span className="text-base font-medium text-gray-900" data-id="element-18029" data-mp="1995jccxrn7eh">
                  Written by Dr. Patricia Reed
                </span>
                <BadgeCheck className="h-5 w-5 text-blue-600" data-id="element-18030" data-mp="21qrekhr37vds" />
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-18031" data-mp="21sug9z1lrcyc">
                Verified Metabolic Health Specialist, Cedar Sinai Medical Center
              </div>
              <div className="flex items-center gap-4 text-sm text-gray-500" data-id="element-18032" data-mp="273gdztf4kn56">
                <div className="flex items-center gap-1" data-id="element-18033" data-mp="2kvwa0a9lzkwl">
                  <ClockIcon className="h-4 w-4" data-id="element-18034" data-mp="2kxh1ts4jgpqr" />
                  <span data-id="element-18035" data-mp="2fxkzdxbhp6db">7 min read</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-18036" data-mp="1s6pap92byraa">
                  <EyeIcon className="h-4 w-4" data-id="element-18037" data-mp="1s78tst3pvlpw" />
                  <span data-id="element-18038" data-mp="1o5vmsfow1che">171,892 views</span>
                </div>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-18039" data-mp="225ereyihq5oy">
            <img src="https://cdn.magicpatterns.com/uploads/nwn6hondxNojcsAjvGQfEj/2.png" alt="Before and after transformation" className="w-full rounded-lg shadow-lg mb-3" data-id="element-18040" data-mp="226g5zcyptabf" />
            <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded border-t border-gray-200" data-id="element-18041" data-mp="3dj8rw74tr4jk">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-18042" data-mp="38kpbem902kyl">
                September 25, 2021
              </span>
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-18043" data-mp="1n2y6or4yjdc3">
                December 7, 2025
              </span>
            </div>
          </div>

          <div className="mb-6" data-id="element-18044" data-mp="1s4nl8gre294x"></div>

          <p className="text-lg font-medium text-gray-700 mb-6 leading-relaxed border-l-4 border-gray-800 pl-4" data-id="element-18045" data-mp="1w44qb92wl49k">
            Before you increase your dose, read this. If the scale has stopped
            moving, your body hasn't built a tolerance — it has hit a "stress
            threshold." Here's how to break through it, or prevent it from ever
            happening.
          </p>

          <div className="border-t border-gray-200 pt-3 mb-6 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-18046" data-mp="2fsdhpgwmh680">
            <div className="mb-1 flex items-center" data-id="element-18047" data-mp="2juic4huwa6vp">
              <span className="font-medium mr-2" data-id="element-18048" data-mp="2jrmfqxyp3q9d">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-18049" data-mp="d5gmojtkort3">
              <span className="font-medium mr-2" data-id="element-18050" data-mp="d33yhox81l7l">Published:</span>
              January 2026
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpPlateau3;